import React from 'react';
import { SelectDropdown } from '@jetshop/ui/Select';
import styled from 'react-emotion';
import {
  SelectableListItem,
  SelectItemWrapper,
  SelectItem,
  StyledCheck,
  StyledCarrot
} from '@jetshop/ui/Select/Components';
import StockStatusIndicator from './StockStatus/StockStatusIndicator';
import StockStatusContainer from '@jetshop/ui/Stock/StockStatusContainer';
import { TopListItem } from '@jetshop/ui/Select/SelectDropdown';
import { Intl } from '@jetshop/intl';

const StyledSelectDropdown = styled(SelectDropdown)`
  ${TopListItem} {
    border: 0.5px solid rgba(0, 0, 0, 0.3);
    border-radius: 2px;
  }
  button {
    :hover {
      background: #f2f2f2;
      transition: 0.3s;
    }
  }
  div > button {
    height: 2.5rem;
    font-weight: bold;
  }

  ${StyledCarrot} {
    transform: rotate(0deg);
    stroke-width: 9;
    &[open] {
      transform: rotate(-180deg);
    }
  }

  .toggleSelect {
    height: 2.5rem;
    background-color: white;
  }
`;

const PickerWrapper = styled('div')`
  width: 100%;

  .header {
    text-align: left;
    margin-top: 1rem;
    font-weight: ${({ theme }) => theme.typo.fontWeightBold};
    display: block;
    padding-bottom: 0.1875rem;
  }
`;

const StyledSelectItemWrapper = styled(SelectItemWrapper)`
  width: 100%;
`;

const StyledSelectItem = styled(SelectItem)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-right: 16px;
`;

const OptionName = styled('p')`
  font-size: 12px;
  color: #00000099;
  margin-bottom: 0.25rem;
`;

const SelectComponentWithStockStatus = ({
  items,
  getItemProps,
  selectedItem,
  selectedItems,
  highlightedIndex
}) => {
  return items.map((item, index) => {
    const active = selectedItem && selectedItem === item;
    const itemIndex = index;
    return (
      <SelectableListItem
        key={itemIndex}
        isHighlighted={highlightedIndex === itemIndex}
        {...item.props}
        {...getItemProps({
          item,
          index: itemIndex
        })}
      >
        <StyledSelectItemWrapper>
          <StyledSelectItem>
            <p> {item.text || item.value}</p>
            <span>
              {item.variant && (
                <StockStatusContainer product={item.variant}>
                  {stockStatus => (
                    <StockStatusIndicator
                      status={stockStatus.status}
                      text={stockStatus.text.replace(/ *\([^)]*\) */g, '')}
                    />
                  )}
                </StockStatusContainer>
              )}
            </span>
          </StyledSelectItem>
        </StyledSelectItemWrapper>
        {active && <StyledCheck />}
      </SelectableListItem>
    );
  });
};

const DefaultPicker = ({ option, ...props }) => (
  <PickerWrapper>
    <OptionName>{option.name}</OptionName>
    <Intl>
      {/* This is necessary to use t for the title string */}
      {t => (
        <StyledSelectDropdown
          {...props}
          data-testid={`${option.name}-select-dropdown`}
          SelectComponent={SelectComponentWithStockStatus}
          title={t('Please select { option }', {
            option: option.name.toLowerCase()
          })}
        />
      )}
    </Intl>
  </PickerWrapper>
);

export default DefaultPicker;
